/**
 * The locale a document's date is written in. Plain English would format as
 * the US month-first 10/14/2026, which a reader in Europe takes for the 10th
 * of the 14th month; English follows the reader's own region instead, and a
 * reader with none gets the day-first British form.
 */
export function docDateLocale(lang: string, browserLanguages?: readonly string[]): string {
  if (lang.split('-')[0] !== 'en' || lang.includes('-')) return lang;
  let tags: readonly string[] = browserLanguages ?? [];
  if (!browserLanguages) {
    try { tags = navigator.languages?.length ? navigator.languages : [navigator.language]; } catch { tags = []; }
  }
  return tags.find((t) => /^en-[a-z]{2}$/i.test(t)) ?? 'en-GB';
}
